import {h, Component} from 'preact'
import TranslationForm from './TranslationForm'

interface Props {
  translationString: string
}

interface State {
  showForm: boolean,
  phrase?: string
}

class TranslationsEdit extends Component<Props, State> {
  constructor () {
    super()
    this.state = {
      showForm: false
    }
    this.hideForm = this.hideForm.bind(this)
    this.showForm = this.showForm.bind(this)
  }

  hideForm () {
    this.setState({showForm: false})
  }

  showForm (event: Event) {
    event.stopPropagation()
    event.preventDefault()
    this.setState({showForm: true})
  }
  render (props: Props, state: State) {
    // Example:
    // ::phrase::category--message--translation--::phrase::
    let [category, message, translation] = props.translationString
      .replace(/\n/g, ' ')
      .replace(/::phrase::/g, '')
      .split('--')

    translation = state.phrase || translation

    return (
      <span>
        {translation}
        <span onClick={this.showForm} className='js-phrase_edit-btn'>edit</span>
        {
          state.showForm &&
          <TranslationForm
            onCallback={this.hideForm}
            onUpdate={(newPhrase: string) => this.setState({phrase: newPhrase})}
            category={category}
            message={message}
            translation={translation}
          />
        }
      </span>
    )
  }
}

export default TranslationsEdit
